import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
export var CardFooter = function CardFooter(props) {
  return React.createElement("div", {
    style: props.style,
    className: classNames('k-card-footer', props.className)
  }, props.children);
};
CardFooter.propTypes = {
  className: PropTypes.string
};